import { CircularProgress, Stack, Typography } from "@hiver/hiver-ui-kit";

const PlaceholderComponent = ({ isLoading, placeholderText }) => (
  <Stack
    sx={{
      backgroundColor: "gray.background",
      width: "100%",
      height: 400,
      justifyContent: "center",
      alignItems: "center",
      gap: 2,
    }}
  >
    {isLoading && <CircularProgress size={40} sx={{ color: "gray.black" }} />}
    <Typography variant="h3">{placeholderText}</Typography>
  </Stack>
);

export default PlaceholderComponent;
